<template>
  <b-modal ref="modal"
    title="New API Key Created"
    ok-title="I have copied my key"
    ok-only
    centered
    @hidden="clearKey">
    <p class="mb-3">
      Copy your new API key now. For security, it will not be shown again.
    </p>
    <div class="d-flex align-items-stretch">
      <code class="flex-grow-1 border rounded-left p-2 key-display overflow-auto">{{ apiKey }}</code>
      <button type="button"
        class="btn btn-outline-secondary rounded-right copy-btn"
        title="Copy to clipboard"
        aria-label="Copy to clipboard"
        @click="copyKey">
        <svg class="icon icon-xs">
          <use xlink:href="#svg-icons_icon-copy" />
        </svg>
      </button>
    </div>
    <input ref="copyInput"
      type="text"
      :value="apiKey"
      style="position: absolute; left: -99999px"
      aria-hidden="true"
      tabindex="-1">
    <small v-if="copied"
      class="text-success mt-1 d-block">Copied!</small>
  </b-modal>
</template>

<script>
export default {
  name: 'UserApiKeyModal',

  data() {
    return {
      apiKey: '',
      copied: false,
    }
  },

  methods: {
    show(key) {
      this.apiKey = key
      this.copied = false
      this.$refs.modal.show()
    },
    clearKey() {
      this.apiKey = ''
      this.copied = false
    },
    copyKey() {
      this.$refs.copyInput.select()
      document.execCommand('copy')
      this.copied = true
      setTimeout(() => { this.copied = false }, 2000)
    },
  },
}
</script>

<style scoped>
.key-display {
  font-size: 0.85rem;
  word-break: break-all;
  white-space: pre-wrap;
}
.copy-btn {
  border-left: none;
  line-height: 1;
  display: flex;
  align-items: center;
}
</style>
